import React, { useRef, useContext, useEffect } from "react"
import styled from "styled-components"
import  { Link } from "gatsby"
import { motion, useAnimation } from "framer-motion"
import { useInView } from 'react-intersection-observer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faAddressBook, faBriefcase} from '@fortawesome/free-solid-svg-icons'
import Context from "context/"
import ContentWrapper from "styles/contentWrapper"

const backgroundImg = "https://hrflow-ai.imgix.net/backgrounds/api-bg.svg"
const backgroundSpot = "https://hrflow-ai.imgix.net/backgrounds/api-spot.svg"


const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    .inner {
      border-radius: 1.5rem;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      border: .1rem solid rgba(48, 191, 217, .2);
      width: 100%;
      height: 20rem;
      padding: 2rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 100%;
        height: 26rem;
        padding: 4rem;
      }
    }
  }
`

const StyledBox = styled.div`
  width: 100%;
  height: 16rem;
  background-image: url(${backgroundSpot}), url(${backgroundImg});
  background-size: cover;
  background-position: center;
  border-radius: 1.5rem;
  display: flex;
  background-repeat: no-repeat;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    height: 18rem;
    h3 {
      margin-bottom: 3rem;
    }
  }
  h3 {
    color: white;
    text-align: center;
    margin-bottom: 0;
    max-width: 48rem;
  }
`

const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    justify-content: flex-start;
  }
  .cta-btn {
    width: auto;
    height: auto;
    font-weight: 700;
    white-space: nowrap;
    text-align: center;
    color: ${({ theme }) => theme.colors.primary};
    text-transform: uppercase;
    border-radius: ${({ theme }) => theme.borderRadius};
    border: 1px solid ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.white};
    transition: 20ms ease-out;
    font-size: 1rem;
    padding: 0.7rem 1rem 0.8rem 1rem;
    margin: 0;
    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }
  }
  .cta-btn.empty {
    border: 1px solid ${({ theme }) => theme.colors.white};
    background: transparent;
    color: ${({ theme }) => theme.colors.white};
    margin-left: 1rem;
    &:hover {
      background-color: rgba(36, 204, 212, 0.4);
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    .cta-btn:first-of-type {
      margin-bottom: 1rem;
    }
    .cta-btn.empty {
      margin-left: 0;
    }
    .cta-btn {
      font-size: 0.8rem;
    }
  }
`

const Explore = ({ content }) => {
  const { frontmatter } = content[0].node
  const { isIntroDone } = useContext(Context).state
  const iControls = useAnimation()

  // Required for animating the image
    const { ref, inView, entry} = useInView({threshold: 0});


  // Only trigger animations if the intro is done or disabled
  useEffect(() => {
    if (inView) iControls.start({ opacity: 1, x: 0 })
  }, [isIntroDone, iControls, inView])

  return (
    <StyledSection id="banner">
      <StyledContentWrapper>
        <motion.div
          className="inner"
          ref={ref}
          initial={{ opacity: 0, x: 20 }}
          animate={iControls}
        >
         <StyledBox>
            <h3>{frontmatter.title}</h3>
            <StyledButtons>
              <a className="cta-btn" href={frontmatter.profileLink} target="_blank" rel="noopener">
                <FontAwesomeIcon className="mr-1" icon={faAddressBook} /><span>{frontmatter.profileTitle}</span>
              </a>
              <a className="cta-btn empty" href={frontmatter.jobLink} target="_blank" rel="noopener">
              <FontAwesomeIcon className="mr-1" icon={faBriefcase} /><span>{frontmatter.jobTitle}</span>
              </a>
            </StyledButtons>
         </StyledBox>
        </motion.div>
      </StyledContentWrapper>
    </StyledSection>
  )
}

export default Explore
